import { Instance, types } from "mobx-state-tree";
import { Attachment } from "@fidget/common/components/mstchat/chatMessage";
import { IntentData, intentResourceDataToSnapshot } from "../../utils";
import { AnyUserReferenceType } from "../../../users/AnyUserReferenceType";
import { Intent } from "../ChatIntent";
import { ChatItemStatus } from "../ChatItemStatus";
import { ChatItemType } from "../ChatItemType";
import { TextChatItem } from "./TextChatItem";

/**
 * Regular chat message posted by user, with optional attachments.
 */
export const UserTextChatItem = types
  .compose(
    "UserTextChatItem",
    TextChatItem,
    types.model({
      type: types.literal(ChatItemType.UserText),
      user: AnyUserReferenceType,
      status: types.optional(
        types.enumeration<ChatItemStatus>("ChatItemStatus", Object.values(ChatItemStatus)),
        ChatItemStatus.SENDING
      ),
      attachments: types.array(Attachment),
      intents: types.array(Intent),
      context: types.maybe(types.frozen<unknown>())
    })
  )
  .extend((self) => {
    const actions = {
      /**
       * Update UserTextChatItem from room_message_updated event
       * @param {any} context update event payload
       */
      updateFromEvent(context: any) {
        Object.assign(self, {
          intents:
            context.intents &&
            context.intents.map((i: IntentData) => intentResourceDataToSnapshot(i))
        });
      }
    };
    return { actions };
  });

export interface IUserTextChatItem extends Instance<typeof UserTextChatItem> { }
